import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CompanyModel } from '../models/companies/company-model';
import { Observable } from 'rxjs/internal/Observable';
import { LocationModel } from '../models/other/location/location-model';
import { QueryModel } from '../models/query/queryModel';
import { PaginationModel } from '../models/pagination/pagination-model';
import { CompanyDetailsModel } from '../models/companies/company-details-model';
import { CompanyRegistrationModel } from '../models/company-registration/company-registration.model';

import { CompanyUpdate } from '../models/company-configuration/company-config-edit';
import { Company } from '../models/company-configuration/company-config-create';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  private resource = `${environment.serverUrl}/companies`;
  private CompanyResource = `${environment.serverUrl}/MazayaCompany`;


  constructor(private http: HttpClient) { }

  getCompaniesP(queryModel: QueryModel): Observable<PaginationModel<CompanyModel>> {
    const url = `${this.resource}/all/page/${queryModel.page}`;
    return this.http.post<any>(url, queryModel);
  }

  getCompanies(): Observable<CompanyModel[]> {
    return this.http.get<CompanyModel[]>(`${this.resource}/all`)
  }
  getCompaniesconfig(): Observable<any> {
    return this.http.get<any>(`${this.CompanyResource}/getallcompanieswithcategorydetails`)
  }
  getCompaniesconfigPage(page: number, search: string): Observable<any> {
    //return this.http.get<any>(`${this.CompanyResource}/getallcompanieswithcategorydetailspagination?pageNumber=${page}`);
    return this.http.get<any>(`${environment.nodeServerUrl}/company-config?page=${page}&limit=16&search=${search}`);
  }


  getCompaniesconfigcreate(company: Company): Observable<any> {
    return this.http.post<any>(`${this.CompanyResource}/createorupdatecompanywithcategory`, company);

  }
  getCompaniesconfigByid(id: number): Observable<any> {
    return this.http.get<any>(`${this.CompanyResource}/getcompanywithcategorydetails?companyId=${id}`)
  }
  getCompanyDeleteByid(id: number, companyConfigUpdate: CompanyUpdate): Observable<any> {
    return this.http.post<any>(`${this.CompanyResource}/deletemazayacompany?companyId=${id}`, companyConfigUpdate);
  }
  getCompanyDeleteByid1(id: number): Observable<any> {
    return this.http.post<any>(`${this.CompanyResource}/deletemazayacompany?companyId=${id}`, null);
  }
  getCompanyRestoreByid(id: number, companyConfigUpdate: CompanyUpdate): Observable<any> {
    return this.http.post<any>(`${this.CompanyResource}/restoremazayacompany?companyId=${id}`, companyConfigUpdate);
  }
  getCompanyRestoreByid1(id: number): Observable<any> {
    return this.http.post<any>(`${this.CompanyResource}/restoremazayacompany?companyId=${id}`, null);
  }
  searchCompanies(query: string, page: number): Observable<any> {
    const url = `${this.CompanyResource}/searchmazayacompany?companyCodeOrName=${query}&pageNumber=${page}`;
    return this.http.get<any>(url);
  }

  getCompany(id: number): Observable<CompanyDetailsModel> {
    const url = `${this.resource}/${id}`;
    return this.http.get<CompanyDetailsModel>(url);
  }

  getCompanyBySupplier(): Observable<CompanyDetailsModel> {
    const url = `${this.resource}/getCompanyByUser`;
    return this.http.get<CompanyDetailsModel>(url);
  }

  getAdministrator(id): Observable<string> {
    const url = `${environment.serverUrl}/administration/get-supplier-admin-for-company/${id}`;
    return this.http.get<string>(url);
  }


  getCompanyLocations(id: string): Observable<LocationModel[]> {
    return this.http.post<LocationModel[]>(`${environment.serverUrl}/companylocation`, { supplierId: id })
  }

  createCompany(company: CompanyDetailsModel): Observable<any> {
    company.website = btoa(unescape(encodeURIComponent(company.website)));
    company.facebook = btoa(unescape(encodeURIComponent(company.facebook)));
    company.instagram = btoa(unescape(encodeURIComponent(company.instagram)));
    company.twitter = btoa(unescape(encodeURIComponent(company.twitter)));
    company.legalForm = btoa(unescape(encodeURIComponent(company.legalForm)));
    return this.http.post<any>(this.resource, company);
  }

  deleteCompany(id: number) {
    const url = `${this.resource}/${id}`;
    return this.http.delete<any>(url);
  }

  getOffersForCompany(id: number) {
    const url = `${this.resource}/${id}/offers`;
    return this.http.get<any>(url);
  }

  hardDeleteOfCompany(id: number) {
    return this.http.delete<any>(`${this.resource}/remove/${id}`);
  }
  registerCompany(company: CompanyRegistrationModel): Observable<any> {
    const url = `${this.resource}/update-trade-licence`;
    return this.http.post<any>(url, company);
  }

  getEligibleSuppliers(): Observable<any> {
    return this.http.get<any>(`${environment.nodeServerUrl}/supplier-configuration/form-values`);
  }
  getSuppliersLandmarksEtc(id: string): Observable<any> {
    return this.http.get<any>(`${environment.nodeServerUrl}/supplier-configuration/form-values/${id}`);
  }

  createNewCompany(rqBody: any): Observable<any> {
    return this.http.post<any>(`${environment.nodeServerUrl}/company-config`, rqBody);
  }
  updateCompany(id: number, rqBody: any): Observable<any> {
    return this.http.put<any>(`${environment.nodeServerUrl}/company-config/${id}`, rqBody);
  }

  editScanLimt(id: number): Observable<any> {
    return this.http.put<any>(`${environment.nodeServerUrl}/company-config/edit-scan-limit/${id}`, null);
  }
  getCompanyDetails(id: number): Observable<any> {
    return this.http.get<any>(`${environment.nodeServerUrl}/company-config/${id}`);
  }

  getCompanySuppliers(id: number): Observable<any> {
    return this.http.get<any>(`${environment.nodeServerUrl}/company-config/${id}/suppliers`);
  }
  getCompanyCoupons(id: number): Observable<any> {
    return this.http.get<any>(`${environment.nodeServerUrl}/company-config/${id}/coupons`);
  }

}
